/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
// Extends From
import Component from '@ember/component';
// Ember imports
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
// External Imports
// Internal Imports
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import Relationship from '@linc-technologies/linced-common/enums/contact-relationship';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { mapBy } from '@linc-technologies/linced-common/utils/arrays';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class SearchResultRow extends Component {
  @service
  session;

  @service
  features;

  @service
  permissions;

  @service
  roles;

  EnrolmentStatus = EnrolmentStatus;
  PersonType = PersonType;
  Relationship = Relationship;
  Jurisdiction = Jurisdiction;
  jurisdictionalIdLabel = 'Student ID';

  @alias('session.school.jurisdiction')
  jurisdiction;

  result = null;
  row = null;
  personCardOpen = false;
  caregiverStudentsOpen = false;

  // canSeeInfo computes whether the current user is able to see the info icon.
  @computed('result.person.{id,type}')
  get canSeeInfo() {
    let person = this.get('result.person');
    if (this.session.personId === person.id) {
      return true;
    }

    switch (person.type) {
      case PersonType.LINC_ED:
        return false;

      case PersonType.STAFF:
        return this.permissions.meet(Scopes.TENANT_ADMIN);
    }

    return !this.roles.currentUserIsRestricted;
  }

  // gender computes the gender to display for this person.
  @computed('result.person.{type,gender,fields.core:staffGender.valueString}')
  get gender() {
    switch (this.get('result.person.type')) {
      case PersonType.CAREGIVER:
        // We don't store genders for caregivers.
        return '';

      case PersonType.STAFF:
        // Staff have their own gender field.
        return this.get('result.person.fields.core:staffGender.valueString');
    }

    // For other people (i.e. learners), return their preferred gender.  Falls
    // back to legal gender.
    return this.get('result.person.preferredGender');
  }

  // learners provides a caregiver's learners filtered for this school
  @computed('result.person.{id,caregiver.learners.[]}')
  get learners() {
    let personId = this.get('result.person.id');
    if (isEmpty(personId)) {
      return [];
    }
    return (this.get('result.person.caregiver.learners') ?? []).filter(
      (learner) => {
        if (learner.get('enrolmentStatus') === EnrolmentStatus.ARCHIVED) {
          return false;
        }
        return mapBy(
          learner.get('learner.contacts') ?? [],
          'caregiverId',
        ).includes(personId);
      },
    );
  }
}
